import axios from 'axios';

const API_URL = 'https://tk5hbbopg3.execute-api.us-east-1.amazonaws.com/prod/investment';

export const GetAllInvestments = async () => {
  try {
    const response = await axios.get(API_URL, {
      headers: {
        'Content-Type': 'application/json',
        // 'Authorization': `Bearer ${token}`
      },
    });

    console.log("InvestmentAPIHelper :: GetAllInvestments :: API Response :: ", JSON.stringify(response, null, 2));

    if (response.status === 200) {
      return response.data;
    } else {
      console.error('Error:', response.status, response.statusText);
      return null;
    }
  } catch (error) {
    console.error('Error:', error);
    return null;
  }
};

export const UpdateInvestment = async (investmentId, portcoId, internalFundId, investmentDate, investmentAmount, investmentRoundId, investmentTypeId) => {
    console.log("InvestmentAPIHelper ::  UpdateInvestment :: " + investmentId + " :: " + portcoId + " :: " + internalFundId + " :: " + investmentRoundId + " :: " + investmentTypeId);
    try {
      const requestBody = {
        portco_id: portcoId,
        internal_fund_id: internalFundId,
        investment_round_id: investmentRoundId,
        investment_type_id: investmentTypeId,
        investment_amount: investmentAmount,
        investment_date: investmentDate
      };
      if (investmentId !== null && investmentId !== "") {
        requestBody.investment_id = investmentId;
      }
      console.log(requestBody);
      const response = await axios.put(API_URL, requestBody, {
        headers: {
          'Content-Type': 'application/json',
          // 'Authorization': `Bearer ${token}`
        },
      });
      
      console.log("InvestmentAPIHelper :: UpdateInvestment :: API Response :: ", JSON.stringify(response, null, 2));
      if (response.status === 200) {
        return response;
      } else {
        console.error('Error:', response.status, response.statusText);
        return null;
      }
    } catch (error) {
      console.error('Error:', error);
      return null;
    }
  };
  

export const DeleteInvestment = async (investmentId) => {
  try {
    const url = `${API_URL}?investmentId=${investmentId}`;

    const response = await axios.delete(url, {
      headers: {
        'Content-Type': 'application/json',
        // 'Authorization': `Bearer ${token}`
      },
    });

    if (response.status === 200) {
      return response;
    } else {
      console.error('Error:', response.status, response.statusText);
      return null;
    }
  } catch (error) {
    console.error('Error:', error);
    return null;
  }
};
